import { render, staticRenderFns } from "./ProviderViewCard.vue?vue&type=template&id=5b5ad6fc&scoped=true"
import script from "./ProviderViewCard.vue?vue&type=script&lang=js"
export * from "./ProviderViewCard.vue?vue&type=script&lang=js"
import style0 from "./ProviderViewCard.vue?vue&type=style&index=0&id=5b5ad6fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5ad6fc",
  null
  
)

export default component.exports